import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Layout from '../../components/layout';
import ProductHero from '../../components/product/ProductHero';
import ProductTestimonials from '../../components/product/ProductTestimonials';
import ProductTwoCol from '../../components/product/ProductTwoCol';

// Utility functions
import localeRedirect from '../../utils/locale';

export const InvoicesPageTemplate = props => {
    const { hero, testimonials, recipients } = props;

    return (
        <>
            <ProductHero {...hero} />

            <ProductTestimonials {...testimonials} />

            <ProductTwoCol {...recipients} />
        </>
    );
};

const InvoicesPage = ({ data }) => {
    localeRedirect(); // Redirect to the user's locale if set in the browser
    const { contentJson: content } = data;

    return (
        <Layout metadata={content.metaData} navbar_style="white">
            <InvoicesPageTemplate {...content} />
        </Layout>
    );
};

export default InvoicesPage;

export const pageQuery = graphql`
    query InvoicesPageTemplate {
        contentJson(path: { eq: "/product/invoices" }) {
            metaData {
                title
                description
                siteName
                url
                keywords
            }
            hero {
                title
                description
                buttons {
                    link
                    text
                    option
                }
                image
                productName
            }
            testimonials {
                title
                description
                points {
                    image
                    header
                    text
                }
                contentBucket
                companies {
                    logo
                    company
                    quote
                    name
                    position
                }
            }
            recipients {
                title
                description
                points {
                    image
                    header
                    text
                }
                images {
                    image
                }
                image_id
            }
        }
    }
`;
